import { defineComponent as _defineComponent } from 'vue'
import { isEqual } from 'lodash-es';
import { Utils } from '@/services/utils/BasicUtils';
import {computed, onMounted, ref, watch} from 'vue';
/*
    it will ignore change in corresponding by index element in value. f.e.
    :value="[someRefWithInitialuUndefined, someNumberRefWithInitialNull, someEmptyArray]" :empty-values="[undefined, null]"
    hack for use of [] in GroupChangesDetection:

    const fetchData = async() => {
    someEmptyArray.value = await Api.getDataForArray();
    // hack for use of [] in GroupChangesDetection
    nextTick(() => {
      hasChanges.value = false; -> hasChanges from parent passed later to :hasChanges.sync="hasChanges"
    });
  }; */
type ModelValue = Array<any>


export default /*#__PURE__*/_defineComponent({
  __name: 'GroupChangesDetection',
  props: {
    value: null,
    hasChanges: { type: Boolean },
    emptyValues: { default: () => [] }
  },
  emits: ["update:hasChanges"],
  setup(__props: any, { emit }: { emit: ({(e: 'update:hasChanges', value: boolean): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { value: [], hasChanges: boolean, emptyValues: [] }





const hasChanges = computed({
  get: () => props.hasChanges,
  set: (value) => {
    emit('update:hasChanges', value);
  },
});
// first not empty value
const initialValue = ref<ModelValue>([]);
// flag which is exposed in scoped slot - it should be true only when new value is different than initialValue
const changed = ref(false);
// stored because Watch handler in deep mode has the same newValue and oldValue
const previousValue = ref<ModelValue>(props.value);

const getClone = (value: ModelValue) => JSON.parse(JSON.stringify(value));

watch(() => props.value, (newValue) => {
  const newValueClone = getClone(newValue);
  const previousValueClone = getClone(previousValue.value);

  const changedIndex = newValueClone.findIndex((item, index) => !isEqual(item, previousValueClone[index]));
  if (changedIndex === -1) {
    return;
  }
  
  const isInitialValueUndefinedOrNull = initialValue.value[changedIndex] === undefined || initialValue.value[changedIndex] === null;
  const isEmptyValueEquivalentToInitial = (props.emptyValues[changedIndex] || props.emptyValues[changedIndex] === null) &&
    isEqual(getClone(props.emptyValues[changedIndex]), getClone(initialValue.value[changedIndex]));
  
  if ((isEmptyValueEquivalentToInitial && !isInitialValueUndefinedOrNull) ||
    (initialValue.value[changedIndex] !== false && (isInitialValueUndefinedOrNull && !isEmptyValueEquivalentToInitial))) {
    initialValue.value = newValueClone;
  } else {
    changed.value = !isEqual(newValueClone, getClone(initialValue.value));
    hasChanges.value = changed.value;
  }

  previousValue.value = newValueClone;
}, { deep: true, });

watch(() => props.hasChanges, (newValue, oldValue) => {
  if (!newValue && !isEqual(getClone(props.value), getClone(initialValue.value))) {
    initialValue.value = getClone(props.value);
  }
}, { deep: true, });

onMounted(() => {
  previousValue.value = getClone(props.value);
  if (!Utils.isEmptyValue(props.value)) {
    initialValue.value = getClone(props.value);
  }
});

return { __sfc: true,props, emit, hasChanges, initialValue, changed, previousValue, getClone }
}

})